import $ from 'jquery';
import useSetEnv from '@global/composable/useSetEnv';
import nanoScroller from '@global/vendors/jquery.nanoscroller.min';

const { setEnv } = useSetEnv();
const isMobile = setEnv.myEquipment();

/**
 * @description 文章頁手機板收合
 * 確定使用品牌: 奶油
 */
function corpPage() {
  const $corp = $('.corp-menu, .corp-content');
  $corp.fadeIn();

  if (isMobile) {
    // 卷軸
    $('.corp-menu > h3').next('ul').wrap('<div class="nanoscroll"></div>');

    $('.nanoscroll > ul').wrap('<div class="nanoscroll__content"></div>');

    setTimeout(() => {
      $('.nanoscroll').nanoScroller({
        contentClass: 'nanoscroll__content',
        alwaysVisible: true,
      });
      $('.corp-menu > h3').on('click tough', () => {
        $('.nanoscroll').toggleClass('open');
      });
    });
  }
}

function useStaticInfoPage() {
  return { corpPage };
}

export default useStaticInfoPage;
